import { motion } from "framer-motion";

export default function ProgressBar({ pct, className = "" }) {
  return (
    <div className={`h-3 w-full overflow-hidden rounded-full bg-[#F3EAE0] ${className}`} data-testid="campaign-progress-bar">
      <motion.div
        className="h-full rounded-full bg-gradient-to-r from-[#FF6D47] to-[#FF9A3D]"
        initial={{ width: 0 }}
        whileInView={{ width: `${Math.min(100, pct || 0)}%` }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
      />
    </div>
  );
}
